/**
 * Shared Rubbl Connect option sets, consumed by both the public Website and Admin so the lists never
 * drift. The string values are the canonical labels stored on leads/deals; their C# mirrors
 * (`ServiceType`, `TrailerType`, `HaulCapabilityTier` in `Rubbl.Common.Contracts.Leads`) must stay
 * byte-identical because matching is a case-insensitive set comparison against the stored values.
 */

/** The service types a Rubbl Connect service provider can offer. Shared by the landing + /connect tab. */
export const SERVICE_TYPE_OPTIONS: string[] = [
  "Field Repair",
  "Preventive Maintenance",
  "Inspection",
  "Hydraulics",
  "Electrical",
  "Welding / Fabrication",
  "Tires / Tracks",
  "Other",
];

/** Largest-equipment capability tiers a hauler can select. `value` is stored; `label` is shown. */
export const HAUL_TIER_OPTIONS: { value: string; label: string }[] = [
  { value: "Light", label: "Light — mini excavators, skid steers, compact track loaders" },
  { value: "Medium", label: "Medium — mid excavators, backhoes, small dozers" },
  { value: "Heavy", label: "Heavy / oversize — large dozers, excavators, graders" },
];

/** Trailer types a hauler can operate. */
export const TRAILER_TYPE_OPTIONS: string[] = ["Bumper-pull", "Gooseneck", "Deckover", "Hotshot", "Lowboy", "RGN"];

/** Stored deal capability -> the label shown in the UI (capability is stored as Reserve/Hauling/Service). */
export const DEAL_CAPABILITY_LABELS = { Reserve: "Machines", Hauling: "Hauling", Service: "Service" } as const;

export type DealCapability = keyof typeof DEAL_CAPABILITY_LABELS;
